import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

interface Props {
    dispatch;
    isChecked: boolean;
}

class AllowOnlyOneKPositionPerLineup extends Component<Props> {
    onChange(isChecked) {
        this.props.dispatch(Action.do('setAllowOnlyOneKPositionPerLineup', isChecked));
    }

    render() {
        const {isChecked} = this.props;

        return (
            <div>
                <InputCheckbox
                    label="Allow only one K per lineup"
                    checked={isChecked}
                    onChange={this.onChange.bind(this)}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters} = state.lineupsData;

    return {
        isChecked: filters.allowOnlyOneKPositionPerLineup,
    };
}

export default connect(mapStatesToProps)(AllowOnlyOneKPositionPerLineup);
